/* tslint:disable */
/* eslint-disable */
/**
 * Navitia API - SNCF
 * Complete API documentation for Navitia/SNCF public transportation API. Based on https://doc.navitia.io
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '@/client/configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '@/client/common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '@/client/base';
// @ts-ignore
import type { CoverageCoverageEquipmentReportsGet200Response } from '@/client/models';
// @ts-ignore
import type { CoverageCoverageLineReportsGet200Response } from '@/client/models';
// @ts-ignore
import type { CoverageCoverageTrafficReportsGet200Response } from '@/client/models';
/**
 * ReportsApi - axios parameter creator
 */
export const ReportsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get equipment reports
         * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
         * @param {string} [filter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coverageCoverageEquipmentReportsGet: async (coverage: string, filter?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'coverage' is not null or undefined
            assertParamExists('coverageCoverageEquipmentReportsGet', 'coverage', coverage)
            const localVarPath = `/coverage/{coverage}/equipment_reports`
                .replace(`{${"coverage"}}`, encodeURIComponent(String(coverage)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get line reports
         * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
         * @param {string} filter 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coverageCoverageLineReportsGet: async (coverage: string, filter: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'coverage' is not null or undefined
            assertParamExists('coverageCoverageLineReportsGet', 'coverage', coverage)
            // verify required parameter 'filter' is not null or undefined
            assertParamExists('coverageCoverageLineReportsGet', 'filter', filter)
            const localVarPath = `/coverage/{coverage}/line_reports`
                .replace(`{${"coverage"}}`, encodeURIComponent(String(coverage)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get line reports for a specific line
         * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
         * @param {string} id Line ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coverageCoverageLinesIdLineReportsGet: async (coverage: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'coverage' is not null or undefined
            assertParamExists('coverageCoverageLinesIdLineReportsGet', 'coverage', coverage)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('coverageCoverageLinesIdLineReportsGet', 'id', id)
            const localVarPath = `/coverage/{coverage}/lines/{id}/line_reports`
                .replace(`{${"coverage"}}`, encodeURIComponent(String(coverage)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get traffic reports
         * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coverageCoverageTrafficReportsGet: async (coverage: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'coverage' is not null or undefined
            assertParamExists('coverageCoverageTrafficReportsGet', 'coverage', coverage)
            const localVarPath = `/coverage/{coverage}/traffic_reports`
                .replace(`{${"coverage"}}`, encodeURIComponent(String(coverage)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReportsApi - functional programming interface
 */
export const ReportsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ReportsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get equipment reports
         * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
         * @param {string} [filter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async coverageCoverageEquipmentReportsGet(coverage: string, filter?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CoverageCoverageEquipmentReportsGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.coverageCoverageEquipmentReportsGet(coverage, filter, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportsApi.coverageCoverageEquipmentReportsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get line reports
         * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
         * @param {string} filter 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async coverageCoverageLineReportsGet(coverage: string, filter: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CoverageCoverageLineReportsGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.coverageCoverageLineReportsGet(coverage, filter, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportsApi.coverageCoverageLineReportsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get line reports for a specific line
         * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
         * @param {string} id Line ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async coverageCoverageLinesIdLineReportsGet(coverage: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CoverageCoverageLineReportsGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.coverageCoverageLinesIdLineReportsGet(coverage, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportsApi.coverageCoverageLinesIdLineReportsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get traffic reports
         * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async coverageCoverageTrafficReportsGet(coverage: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CoverageCoverageTrafficReportsGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.coverageCoverageTrafficReportsGet(coverage, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportsApi.coverageCoverageTrafficReportsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ReportsApi - factory interface
 */
export const ReportsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ReportsApiFp(configuration)
    return {
        /**
         * 
         * @summary Get equipment reports
         * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
         * @param {string} [filter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coverageCoverageEquipmentReportsGet(coverage: string, filter?: string, options?: RawAxiosRequestConfig): AxiosPromise<CoverageCoverageEquipmentReportsGet200Response> {
            return localVarFp.coverageCoverageEquipmentReportsGet(coverage, filter, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get line reports
         * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
         * @param {string} filter 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coverageCoverageLineReportsGet(coverage: string, filter: string, options?: RawAxiosRequestConfig): AxiosPromise<CoverageCoverageLineReportsGet200Response> {
            return localVarFp.coverageCoverageLineReportsGet(coverage, filter, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get line reports for a specific line
         * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
         * @param {string} id Line ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coverageCoverageLinesIdLineReportsGet(coverage: string, id: string, options?: RawAxiosRequestConfig): AxiosPromise<CoverageCoverageLineReportsGet200Response> {
            return localVarFp.coverageCoverageLinesIdLineReportsGet(coverage, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get traffic reports
         * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coverageCoverageTrafficReportsGet(coverage: string, options?: RawAxiosRequestConfig): AxiosPromise<CoverageCoverageTrafficReportsGet200Response> {
            return localVarFp.coverageCoverageTrafficReportsGet(coverage, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ReportsApi - interface
 */
export interface ReportsApiInterface {
    /**
     * 
     * @summary Get equipment reports
     * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
     * @param {string} [filter] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    coverageCoverageEquipmentReportsGet(coverage: string, filter?: string, options?: RawAxiosRequestConfig): AxiosPromise<CoverageCoverageEquipmentReportsGet200Response>;

    /**
     * 
     * @summary Get line reports
     * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
     * @param {string} filter 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    coverageCoverageLineReportsGet(coverage: string, filter: string, options?: RawAxiosRequestConfig): AxiosPromise<CoverageCoverageLineReportsGet200Response>;

    /**
     * 
     * @summary Get line reports for a specific line
     * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
     * @param {string} id Line ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    coverageCoverageLinesIdLineReportsGet(coverage: string, id: string, options?: RawAxiosRequestConfig): AxiosPromise<CoverageCoverageLineReportsGet200Response>;

    /**
     * 
     * @summary Get traffic reports
     * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    coverageCoverageTrafficReportsGet(coverage: string, options?: RawAxiosRequestConfig): AxiosPromise<CoverageCoverageTrafficReportsGet200Response>;

}

/**
 * ReportsApi - object-oriented interface
 */
export class ReportsApi extends BaseAPI implements ReportsApiInterface {
    /**
     * 
     * @summary Get equipment reports
     * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
     * @param {string} [filter] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public coverageCoverageEquipmentReportsGet(coverage: string, filter?: string, options?: RawAxiosRequestConfig) {
        return ReportsApiFp(this.configuration).coverageCoverageEquipmentReportsGet(coverage, filter, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get line reports
     * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
     * @param {string} filter 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public coverageCoverageLineReportsGet(coverage: string, filter: string, options?: RawAxiosRequestConfig) {
        return ReportsApiFp(this.configuration).coverageCoverageLineReportsGet(coverage, filter, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get line reports for a specific line
     * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
     * @param {string} id Line ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public coverageCoverageLinesIdLineReportsGet(coverage: string, id: string, options?: RawAxiosRequestConfig) {
        return ReportsApiFp(this.configuration).coverageCoverageLinesIdLineReportsGet(coverage, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get traffic reports
     * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public coverageCoverageTrafficReportsGet(coverage: string, options?: RawAxiosRequestConfig) {
        return ReportsApiFp(this.configuration).coverageCoverageTrafficReportsGet(coverage, options).then((request) => request(this.axios, this.basePath));
    }
}

